import { hasProtocol } from 'ufo'

/**
 * 检查链接是否以http或https开头/外部链接
 * @param link 链接
 * @returns {boolean} 是否是外部链接
 */
export const useCheckOutLink = (url: string): boolean => {
  return hasProtocol(url)
}
